/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SupportTypeEnum } from './supportTypeEnum';

export interface TeacherTargetCreate { 
    title: string;
    /**
     * Odhadovaný termín naplnění cíle.
     */
    fulfillmentDate: string;
    /**
     * Kolik času pedagog odhaduje na splnění tohoto cíle.
     */
    estimatedTime: number;
    /**
     * Jaká forma podpory je k naplnění cíle potřeba.  * `financial` - Finance * `material` - Materiál * `organizational` - Organizační
     */
    supportType: SupportTypeEnum;
}